import { Box, Tooltip, Typography } from "@mui/material";
import type { NpiActivity } from "../types/npi-project.types";
import { getActivityDateLabel, getActivityStatusStyle } from "../utils/activity.utils";
import { activityCellSx, ATTENTION_STYLE, CRITICAL_DELAY_DAYS, DEFAULT_ACTIVITY_STYLE, STATUS_STYLES } from "../constants/dashboard.constants";
import { CalendarMonth } from "@mui/icons-material";
import { translate } from "../../../../../translate/translate";
import { Stack } from "@mui/system";

interface ActivityStatusCellProps {
  activity?: NpiActivity;
}

export const NpiDashboardTaskStatusCell = ({ activity }: ActivityStatusCellProps) => {
  const style = activity
    ? getActivityStatusStyle(activity)
    : DEFAULT_ACTIVITY_STYLE;

  const delayDays = activity?.delayDays ?? 0;
  const doneWithDelay = activity?.status == "concluido" && delayDays > 0;

  return (
    <Stack
      alignItems='center'
      direction='row'
      sx={{
        ...activityCellSx,
        border: `1px ${style.dashed ? "dashed" : "solid"} ${style.border}`,
        backgroundColor: style.background,
        color: style.color,
      }}
    >
      {activity && (
        <>
          <Box>
            <Typography
              noWrap
              sx={{
                fontSize: "14px",
                fontWeight: 700,
                color: "inherit",
                maxWidth: "90%",
              }}
            >
              {activity.statusFinal}
            </Typography>
            <Typography
              sx={{ fontSize: "13px", color: "inherit", opacity: 0.85 }}
            >
              {getActivityDateLabel(activity)}
            </Typography>
          </Box>

          {doneWithDelay && <>
            <Tooltip title={translate.t("completed_late_days", { count: activity.delayDays })}>
              <CalendarMonth
                fontSize="large"
                sx={{
                  color: (delayDays >= CRITICAL_DELAY_DAYS ? STATUS_STYLES.atrasado : ATTENTION_STYLE).color,
                }}
              />
            </Tooltip>
          </>}
        </>
      )}
    </Stack>
  );
};
